import Vue from "vue"
import store from "@/store";

/**
 * 获取用户的按钮权限id
 * @param array
 * @returns {*}
 */
function dealBtnArr(array) {
  array = store.getters.permission_btns.map(item => {
    return item
  })
  return array
}

/**
 * 匹配用户的按钮权限id
 * @param params
 * @returns {boolean}
 */
function hasPer(params) {
  var permission_btn = dealBtnArr(store.getters.permission_btns);
  return permission_btn.indexOf(params) > -1
}

/**
 * vue指令操作按钮隐藏显示
 */
Vue.directive('hasBtn', {
  inserted: (el, binding, vnode) => {
    if (!hasPer(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})

